module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hrbeo"))).then(() => parcelRequire('1iHdE'));